import * as types from './constants'
import apiService, { setAxiosHeader } from '../../apiService/apiService'

export const login = (mobile, password, history) => {
    const data = {
        userName: mobile,
        password,
    }
    return (dispatch) => {
        dispatch({
            type: types.AUTH_START,
        })
        apiService.auth
            .login(data)
            .then((response) => {
                if (response.status == 200) {
                    const { token } = response.data
                    if (token) {
                        localStorage.setItem('token', token)
                        setAxiosHeader(token)
                        dispatch({
                            type: types.AUTH_SUCCESS,
                            token: token,
                            isUserValidated: false,
                        })
                        window.location.href = '/'
                        return
                    }

                    dispatch({
                        type: types.AUTH_SUCCESS,
                        token: null,
                        isUserValidated: false,
                    })
                } else {
                    dispatch({
                        type: types.AUTH_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                if (error?.response?.status == '403') {
                    dispatch({
                        type: types.AUTH_SUCCESS,
                        token: null,
                        isUserValidated: false,
                    })
                    return
                }
                let errorMessage = 'خطا در اجرای دستور'
                if (error?.response?.data) errorMessage = error.response.data
                else if (error?.data) errorMessage = error.data

                dispatch({

                    type: types.AUTH_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const validateUser = (mobile, validationKey, history) => {
    const data = {
        userName: mobile,
        token: validationKey,
    }
    return (dispatch) => {
        dispatch({
            type: types.VALIDATION_START,
        })
        apiService.auth
            .validateUser(data)
            .then((response) => {
                if (response.status == 200) {
                    const { token } = response.data
                    localStorage.setItem('token', token)
                    setAxiosHeader(token)
                    dispatch({
                        type: types.VALIDATION_SUCCESS,
                        payload: token,
                    })
                    window.location.href = '/'
                } else {
                    dispatch({
                        type: types.VALIDATION_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.VALIDATION_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const logout = () => {
    return (dispatch) => {
        localStorage.removeItem('token')
        dispatch({
            type: types.LOG_OUT,
        })
        window.location.href = '/'
    }
}

export const setError = (message) => {
    return (dispatch) => {
        dispatch({
            type: types.SET_ERROR,
            error: message,
        })
    }
}

export const sendForgotPasswordToken = (mobile) => {
    return (dispatch) => {
        dispatch({
            type: types.FORGOT_PASSWORD_STEP_ONE_START,
        })
        apiService.auth
            .forgotPasswordStepOne(mobile)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.FORGOT_PASSWORD_STEP_ONE_SUCCESS,
                    })
                } else {
                    dispatch({
                        type: types.FORGOT_PASSWORD_STEP_ONE_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.FORGOT_PASSWORD_STEP_ONE_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const forgotPasswordFinalStep = (mobile, token, password, history) => {
    const data = {
        userName: mobile,
        password: password,
        token: token,
    }
    return (dispatch) => {
        dispatch({
            type: types.FORGOT_PASSWORD_STEP_TWO_START,
        })
        apiService.auth
            .forgotPasswordStepTwo(data)
            .then((response) => {
                if (response.status == 200) {
                    const { token } = response.data
                    localStorage.setItem('token', token)
                    setAxiosHeader(token)
                    dispatch({
                        type: types.FORGOT_PASSWORD_STEP_TWO_SUCCESS,
                    })
                    window.location.href = '/'
                } else {
                    dispatch({
                        type: types.FORGOT_PASSWORD_STEP_TWO_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.FORGOT_PASSWORD_STEP_TWO_FAIL,
                    error: errorMessage,
                })
            })
    }
}
